import React, { createContext } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Store from './store/userStore';
import BviStore from './store/bviStore';
import DistantStore from './store/distantStore';

interface State {
    store: Store,
    bviStore: BviStore,
    distantStore: DistantStore
}

const store = new Store();
const bviStore = new BviStore();
const distantStore = new DistantStore();

export const Context = createContext<State>({
    store, bviStore, distantStore
})

ReactDOM.render(
    <Context.Provider value={{store, bviStore, distantStore}}>
        <App />
    </Context.Provider>,
    
document.getElementById('root'));